import { faAngleRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import { FC, ReactNode } from 'react'
import { colors } from '../../theme/colors'
import Link from '../Link'

export interface BreadcrumbsProps {
  links: Array<{
    href: string
    label: string
  }>
  endLabel: ReactNode
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ links, endLabel }) => (
  <MuiBreadcrumbs
    aria-label="breadcrumb"
    separator={<FontAwesomeIcon icon={faAngleRight} className="text-ink-800" />}
  >
    {links.map((link) => (
      <Link key={link.href} href={link.href}>
        <Typography variant="p2" sx={{ color: colors.Blue[600] }} className="underline">
          {link.label}
        </Typography>
      </Link>
    ))}
    <Typography variant="p2" sx={{ color: colors.Ink[700] }}>
      {endLabel}
    </Typography>
  </MuiBreadcrumbs>
)

export default Breadcrumbs
